<div #scrollContainer class="container" [ngClass]="{'ionic': useIonic}">
    <!--_____________________ROUTE_____________________-->
    <div *ngIf="route">
        <div class="title">
            {{'SHARED.ROUTE.LINKS.COMPONENT.TITLE' | translate}}
        </div>

        <div class="col-x">
            <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.CAPTION' | translate}}</div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('terceros', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.RESERVATIONSINGLE' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('terceros')"></shared-copyclipboard>
            </div>

            <div *ngIf="shipments && shipments.length > 0">
                <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.CAPTION' | translate}}</div>

                <div *ngIf="shipments && shipments.length > 1">
                    <div *ngFor="let item of shipments" class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKING' | translate:{ shipmentKey:
                            getString(item.shipmentKey),
                            originSkinAddress: getString(item.originSkinAddress),
                            destinationSkinAddress: getString(item.destinationSkinAddress) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
                    </div>
                </div>

                <div *ngIf="shipments && shipments.length == 1">
                    <div *ngFor="let item of shipments" class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKINGSINGLE' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
                    </div>
                </div>
            </div>

            <div class="normal-title" *ngIf="showTotemTitle">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' | translate}}
            </div>

            <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' | translate}}</div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemRoute', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFY' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemRoute')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemEnterRoute', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRY' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemEnterRoute')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemExitRoute', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXIT' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemExitRoute')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemSignatureRoute', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGN' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemSignatureRoute')"></shared-copyclipboard>
            </div>



            <div *ngIf="phases">
                <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEMPHASE.CAPTION' | translate}}
                </div>
                <div class="links-totem" *ngFor="let item of phases">
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('totem', null, item)">
                            {{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYOF' | translate:{ addressSkin:
                            getString(item.addressSkin) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('totem', null, item)"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('totemEnter', null, item)">
                            {{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRYOF' | translate:{ addressSkin:
                            getString(item.addressSkin) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('totemEnter', null, item)"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('totemExit', null, item)">
                            {{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXITOF' | translate:{ addressSkin:
                            getString(item.addressSkin) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('totemExit', null, item)"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('totemSignature', null, item)">
                            {{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGNOF' | translate:{ addressSkin:
                            getString(item.addressSkin) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('totemSignature', null, item)"></shared-copyclipboard>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--_____________________PHASE_____________________-->
    <div *ngIf="phase">
        <div class="title">
            {{'SHARED.PHASE.LINKS.COMPONENT.TITLE' | translate}}
        </div>

        <div class="col-x">
            <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.CAPTION' | translate}}</div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('terceros', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.RESERVATIONSINGLE' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('terceros')"></shared-copyclipboard>
            </div>

            <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SIGN' | translate}}</div>
            <div class="link-with-copy" *ngIf="hardmanUser">
                <button-link class="line left" (linkClick)="onClickLinkOption('signatureEnter', null, null)">
                    {{'SHARED.ROUTE.LINKS.CAPTIONS.SIGNONEXIT' | translate}}
                </button-link>
                <shared-copyclipboard [value]="getLink('signatureEnter')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('signatureExit', null, null)">
                    {{'SHARED.ROUTE.LINKS.CAPTIONS.SIGNONENTRY' | translate}}
                </button-link>
                <shared-copyclipboard [value]="getLink('signatureExit')"></shared-copyclipboard>
            </div>

            <div *ngIf="shipments && shipments.length > 0">
                <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.CAPTION' | translate}}</div>

                <div *ngIf="shipments && shipments.length > 1">
                    <div *ngFor="let item of shipments" class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKING' | translate:{ shipmentKey:
                            getString(item.shipmentKey),
                            originSkinAddress: getString(item.originSkinAddress),
                            destinationSkinAddress: getString(item.destinationSkinAddress) } }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
                    </div>
                </div>

                <div *ngIf="shipments && shipments.length == 1">
                    <div *ngFor="let item of shipments" class="link-with-copy">
                        <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKINGSINGLE' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
                    </div>
                </div>
            </div>

            <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' | translate}}</div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totem', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFY' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totem')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemEnter', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRY' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemEnter')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemExit', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXIT' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemExit')"></shared-copyclipboard>
            </div>
            <div class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('totemSignature', null, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGN' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('totemSignature')"></shared-copyclipboard>
            </div>
        </div>
    </div>
</div>